<template>
  <header
    class="modern-header d-flex align-items-center justify-content-between px-3 py-0"
  >
    <!-- 🧩 Left: Logo -->
    <div class="d-flex align-items-center">
      <img src="../../../public/logo.png" class="logo me-3" />
      <div class="d-none d-md-block">
        <NewsTickerVue />
      </div>
    </div>

    <!-- ⚙️ Right: Actions -->
    <div class="d-flex align-items-center gap-2">
      <!-- Notifications (Admin only) -->
      <button
        v-if="isAdmin"
        class="action-btn notification-btn"
        @click="showNotifications"
        title="Notifications"
      >
        <i class="bi bi-bell"></i>
        <span v-if="notificationCount > 0" class="notification-badge">
          {{ notificationCount > 9 ? "9+" : notificationCount }}
        </span>
      </button>

      <!-- Settings -->
      <button
        class="action-btn"
        @click="$router.push({ name: 'settings-index' })"
      >
        <i class="bi bi-gear-wide-connected"></i>
      </button>

      <!-- Share -->
      <button class="action-btn" @click="openShareModal">
        <i class="bi bi-share-fill"></i>
      </button>

      <!-- Profile -->
      <div class="dropdown">
        <button
          class="action-btn d-flex align-items-center"
          @click="toggleLogout"
        >
          <i class="bi bi-person-circle me-1"></i>
          <span class="fw-semibold">{{ authData.name }}</span>
        </button>
        <div v-if="logout_display" class="logout-card">
          <button class="btn btn-danger w-100" @click="logout">
            <i class="bi bi-box-arrow-right me-1"></i> Déconnecter
          </button>
        </div>
      </div>
    </div>

    <!-- 🌐 Share Modal -->
    <global-modal
      :visible="showShareModal"
      title="Partager la page"
      modal-width="500px"
      @close="showShareModal = false"
    >
      <template v-slot:body>
        <div>
          <label class="form-label fw-semibold">Remarque</label>
          <textarea
            v-model="remark"
            placeholder="Message..."
            class="form-control"
          ></textarea>
        </div>

        <div class="user-list mt-3">
          <div
            v-for="user in users"
            :key="user.reference"
            class="user-item"
            @click="shareWithUser(user)"
          >
            <i class="bi bi-person-circle fs-4 me-3"></i>
            <div>
              <div class="fw-bold text-primary">{{ user.name }}</div>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <button class="btn btn-light" @click="showShareModal = false">
          Annuler
        </button>
      </template>
    </global-modal>
  </header>
</template>

<script>
import NewsTickerVue from "../cards/NewsTicker.vue";
// import AlertVue from "../../views/notification/Alert.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    NewsTickerVue,
    // AlertVue,
  },
  data() {
    return {
      display_sidebar: false,
      logout_display: false,
      showShareModal: false,
      searchQuery: "",
      remark: "",
    };
  },
  computed: {
    ...mapGetters("auth", {
      authData: "getAuthData",
      settings: "getSettings",
      userRole: "getUserRole",
    }),
    ...mapGetters("user", {
      users: "getAll",
    }),
    ...mapGetters("notification", {
      notifications: "getNotifications",
    }),
    filteredUsers() {
      return this.users.filter(
        (user) =>
          user.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          user.email.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    notificationCount() {
      return this.notifications ? this.notifications.length : 0;
    },
    isAdmin() {
      // Check if user is connected and has admin role
      if (!this.authData || !this.userRole) {
        return false;
      }
      // Check if role is "Admin" (case-insensitive)
      const role = this.userRole.toLowerCase();
      return role === "admin";
    },
    isUserConnected() {
      return this.authData && (this.authData.id || this.authData.reference);
    },
  },
  methods: {
    // ...mapActions("share", ["shareWithUser"]),

    toggleLogout() {
      this.logout_display = !this.logout_display;
    },

    logout() {
      this.$store.dispatch("auth/logout");
    },

    openShareModal() {
      this.showShareModal = true;
      this.$store.dispatch("user/getAll");
    },

    shareWithUser(user) {
      const routeData = {
        sharedWith: user.reference,
        routeName: this.$route.name,
        params: this.$route.params,
        query: this.$route.query,
        remark: this.remark,
      };

      this.$store
        .dispatch("share/store", routeData)
        .then(() => {
          this.$toast.success("Successfully shared!");
          this.showShareModal = false;
        })
        .catch((error) => {
          this.$toast.error("Failed to share: " + error.message);
        });
    },

    getWindowWidth() {
      return document.documentElement.clientWidth;
    },

    showNotifications() {
      if (this.notifications && this.notifications.length > 0) {
        // Show notifications in a toast or modal
        // For now, just show the latest notification
        const latest = this.notifications[this.notifications.length - 1];
        this.$toast[latest.type || "info"](latest.message);
      } else {
        this.$toast.info("Aucune notification");
      }
    },
    
    loadNotifications() {
      // Load notifications for admin users
      if (this.isAdmin && this.isUserConnected) {
        // You can add API call here to fetch notifications
        // For example: this.$store.dispatch("notification/fetchAll");
        // Or set up real-time notifications via Pusher/WebSocket
        console.log("Loading notifications for admin user");
      }
    },
  },
  mounted() {
    // Load notifications when component mounts if user is admin
    if (this.isAdmin && this.isUserConnected) {
      this.loadNotifications();
    }
  },
  watch: {
    // Watch for user connection changes
    isUserConnected(newVal) {
      if (newVal && this.isAdmin) {
        this.loadNotifications();
      }
    },
    // Watch for role changes
    isAdmin(newVal) {
      if (newVal && this.isUserConnected) {
        this.loadNotifications();
      }
    },
  },
};
</script>

<style scoped>
.modern-header {
  background: rgb(4, 108, 193) !important;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* Logo */
.logo {
  height: 45px;
  width: auto;
  transition: transform 0.3s ease;
}
.logo:hover {
  transform: scale(1.05);
}

/* Action buttons */
.action-btn {
  background: #f8f9fa;
  border: none;
  border-radius: 10px;
  color: #333;
  padding: 0.5rem 0.7rem;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;
}
.action-btn:hover {
  background: #0d6efd;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 3px 8px rgba(13, 110, 253, 0.3);
}

.notification-btn {
  position: relative;
}

.notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  border-radius: 10px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0 4px;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Logout dropdown */
.logout-card {
  position: absolute;
  right: 0;
  top: 60px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  padding: 0.8rem;
  width: 180px;
  z-index: 999;
  animation: fadeIn 0.2s ease;
}
.logout-card button {
  border-radius: 8px;
}

/* Share Modal */
.user-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.6rem;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}
.user-item:hover {
  background-color: #f3f4f6;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .modern-header {
    flex-wrap: wrap;
    padding: 0.8rem;
  }
  .logo {
    height: 40px;
  }
  .action-btn {
    padding: 0.4rem 0.5rem;
    font-size: 1rem;
  }
}
</style>
